import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

export default class FestivalScheduleMobileNav extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    isOpen: false
  }

  toggle = () => {

    this.setState({isOpen: !this.state.isOpen})
  }

  handleNavClick = action => {
    this.props.setScheduleView(action);
    this.setState({isOpen: false})
  }

  render() {

    let iconClasses = classnames({
      'fa': true,
      'fa-chevron-up': this.state.isOpen,
      'fa-chevron-down': !this.state.isOpen,
      'fa-2x': false
    });

    let subNav = '';

    if (this.state.isOpen) {
      subNav = <div className="festivalSchedule-subnavList">
        <div onClick={this.handleNavClick.bind(this, 'timesEvents')} className="festivalSchedule-subnavItem">
          All events
        </div>
        <div onClick={this.handleNavClick.bind(this, 'categoriesEvents')} className="festivalSchedule-subnavItem">
          Categories of events
        </div>
      </div>;
    } else {
      subNav = '';
    }

    return(
      <div>
        <div className="festivalSchedule-navWrapper">

          <div onClick={this.toggle} className="festivalSchedule-navTitle">View schedule by <i className={iconClasses}></i></div>



          {subNav}


        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/festival/schedule/FestivalScheduleMobileNav.jsx